import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["phone", "country", "fallback", "format"],
  _excluded2 = ["suspenseFallback"];
import { Link } from '@material-ui/core';
import { renderChildren } from '@superdispatch/ui';
import { forwardRef, Suspense, useMemo } from 'react';
import { usePhoneService } from "../phone-service/PhoneService.js";
import { jsx as _jsx } from "react/jsx-runtime";
export var PhoneLink = /*#__PURE__*/forwardRef((_ref, ref) => {
  var {
      phone,
      country,
      fallback,
      format = 'international'
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  var service = usePhoneService();
  var [text, href] = useMemo(() => {
    if (service.checkPossibility(phone) !== 'is-possible') {
      return [undefined, undefined];
    }
    return [service.format(phone, {
      country,
      format
    }), service.format(phone, {
      country,
      format: 'rfc3966'
    })];
  }, [phone, country, format, service]);
  return !href ? renderChildren(fallback) : /*#__PURE__*/_jsx(Link, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    href: href,
    children: text
  }));
});
if (process.env.NODE_ENV !== "production") PhoneLink.displayName = "PhoneLink";
export var SuspendedPhoneLink = /*#__PURE__*/forwardRef((_ref2, ref) => {
  var {
      suspenseFallback = null
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsx(Suspense, {
    fallback: suspenseFallback,
    children: /*#__PURE__*/_jsx(PhoneLink, _objectSpread(_objectSpread({}, props), {}, {
      ref: ref
    }))
  });
});
if (process.env.NODE_ENV !== "production") SuspendedPhoneLink.displayName = "SuspendedPhoneLink";